import React, {useContext} from 'react';
import "./meet.scss";
import { AppContext } from '../../services/translationContext';
import { InsightsSection } from '../../components/sections/insights/insights';
import { ClientStoriesSection } from '../../components/sections/client-stories/client-stories';
import { PageHero } from '../../components/page-hero/page-hero';
import { EventsSection } from '../../components/sections/events/events';
import parse from 'html-react-parser';

export const Meet = () => {
  const { services: {TranslationsService} } = useContext(AppContext);
  document.title = `${TranslationsService.labels(`menu.insights.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;

  const megastring = `
    <section class="hero-meet">
      <div class="hero-meet-bg-num">AI</div>

      <div class="hero-meet-top">
        <a href="https://www.sydea.it" class="logo-meet">Sydea<span>.</span></a>
        <span class="event-pill-meet">We Make Future &mdash; Bologna 2026</span>
      </div>

      <div class="hero-meet-center">
        <p class="hero-meet-eyebrow">AI &bull; ERP &bull; Automation</p>
        <h1 class="hero-meet-headline">
          Portiamo<br/>
          <mark>intelligenza</mark><br/>
          nei tuoi processi.
        </h1>
        <p class="hero-meet-sub">
          Sydea progetta sistemi AI, integra piattaforme ERP e automatizza i flussi operativi per aziende che vogliono crescere.
          <em>We design AI systems, integrate ERP platforms, and automate operational workflows for businesses built to scale.</em>
        </p>
        <a href="mailto:info@sydea.com?subject=Contatto%20da%20We%20Make%20Future%202026&body=Ciao%20Sydea%2C%0A%0Aho%20ricevuto%20il%20vostro%20biglietto%20da%20visita%20al%20We%20Make%20Future%20e%20mi%20piacerebbe%20approfondire.%0A%0ANome%3A%20%0AAzienda%3A%20%0AInteresse%3A%20%0A" class="btn-cta-meet">
          Scrivici &mdash; Get in touch <span class="arrow">&rarr;</span>
        </a>
      </div>

      <div class="hero-meet-bottom">
        <div class="hero-meet-contact-info">
          <div class="contact-item-meet">
            <span class="contact-item-meet-label">Web</span>
            <span class="contact-item-meet-val"><a href="https://www.sydea.it" target="_blank">sydea.it</a></span>
          </div>
          <div class="contact-item-meet">
            <span class="contact-item-meet-label">Email</span>
            <span class="contact-item-meet-val"><a href="mailto:info@sydea.com">info@sydea.com</a></span>
          </div>
        </div>
        <p class="hero-meet-sedi">Bologna &mdash; Napoli &mdash; Skopje &mdash; Vancouver</p>
      </div>
    </section>

    <div class="ticker-meet">
      <div class="ticker-meet-track">
        <span class="ticker-meet-item hl">Sydea</span>
        <span class="ticker-meet-item">AI Systems</span>
        <span class="ticker-meet-item hl">ERP Integration</span>
        <span class="ticker-meet-item">Workflow Automation</span>
        <span class="ticker-meet-item hl">SAP</span>
        <span class="ticker-meet-item">Odoo</span>
        <span class="ticker-meet-item hl">Software Development</span>
        <span class="ticker-meet-item">Bologna &mdash; Napoli &mdash; Skopje< &mdash; Vancouver</span>
        <span class="ticker-meet-item hl">We Make Future 2026</span>
        <span class="ticker-meet-item">IT Consulting</span>
        <span class="ticker-meet-item hl">Sydea</span>
        <span class="ticker-meet-item">AI Systems</span>
        <span class="ticker-meet-item hl">ERP Integration</span>
        <span class="ticker-meet-item">Workflow Automation</span>
        <span class="ticker-meet-item hl">SAP</span>
        <span class="ticker-meet-item">Odoo</span>
        <span class="ticker-meet-item hl">Software Development</span>
        <span class="ticker-meet-item">Bologna &mdash; Napoli &mdash; Skopje< &mdash; Vancouver</span>
        <span class="ticker-meet-item hl">We Make Future 2026</span>
        <span class="ticker-meet-item">IT Consulting</span>
      </div>
    </div>

    <section class="services-meet">
      <p class="section-label-meet">Cosa facciamo</p>
      <div class="services-meet-grid">
        <div class="service-card-meet">
          <p class="service-num-meet">01</p>
          <h2 class="service-title-meet">AI Systems</h2>
          <p class="service-desc-meet">
            Progettiamo e integriamo agenti intelligenti, pipeline di dati e modelli AI nei processi aziendali esistenti.
            <em>We design and integrate intelligent agents, data pipelines, and AI models into existing business processes.</em>
          </p>
          <div class="service-tags-meet">
            <span class="tag-meet">LLM integration</span>
            <span class="tag-meet">Document AI</span>
            <span class="tag-meet">Predictive</span>
          </div>
        </div>
        <div class="service-card-meet">
          <p class="service-num-meet">02</p>
          <h2 class="service-title-meet">ERP Integration</h2>
          <p class="service-desc-meet">
            Implementiamo e integriamo SAP, Odoo e soluzioni custom adattandole alla struttura operativa di ogni azienda.
            <em>We implement and integrate SAP, Odoo, and custom solutions tailored to each company's operational structure.</em>
          </p>
          <div class="service-tags-meet">
            <span class="tag-meet">SAP</span>
            <span class="tag-meet">Odoo</span>
            <span class="tag-meet">E-invoicing</span>
          </div>
        </div>
        <div class="service-card-meet">
          <p class="service-num-meet">03</p>
          <h2 class="service-title-meet">Workflow Automation</h2>
          <p class="service-desc-meet">
            Mappiamo e automatizziamo i flussi operativi ripetitivi, riducendo errori e liberando risorse per attivit&agrave; ad alto valore.
            <em>We map and automate repetitive operational flows, reducing errors and freeing resources for high-value work.</em>
          </p>
          <div class="service-tags-meet">
            <span class="tag-meet">Process mapping</span>
            <span class="tag-meet">RPA</span>
            <span class="tag-meet">Integration</span>
          </div>
        </div>
      </div>
    </section>

    <div class="cta-band-meet">
      <div>
        <h2 class="cta-band-meet-headline">Ci siamo incontrati.<br/>Continuiamo a parlare.</h2>
        <p class="cta-band-meet-sub">Scrivici direttamente &mdash; l'oggetto &egrave; gi&agrave; precompilato.<br/><em style="font-style:normal; color: rgba(26,25,23,0.45);">Write to us directly &mdash; subject line already filled in.</em></p>
      </div>
      <a href="mailto:info@sydea.com?subject=Contatto%20da%20We%20Make%20Future%202026&body=Ciao%20Sydea%2C%0A%0Aho%20ricevuto%20il%20vostro%20biglietto%20da%20visita%20al%20We%20Make%20Future%20e%20mi%20piacerebbe%20approfondire.%0A%0ANome%3A%20%0AAzienda%3A%20%0AInteresse%3A%20%0A" class="btn-dark-meet">
        Scrivici &rarr;
      </a>
    </div>

    <section class="about-meet">
      <div>
        <h2 class="about-meet-headline">IT consulting<br/>italiano,<br/>visione globale.</h2>
        <div class="about-meet-stats">
          <div>
            <span class="stat-val-meet">50+</span>
            <span class="stat-label-meet">persone</span>
          </div>
          <div>
            <span class="stat-val-meet">3</span>
            <span class="stat-label-meet">sedi</span>
          </div>
          <div>
            <span class="stat-val-meet">15+</span>
            <span class="stat-label-meet">anni</span>
          </div>
        </div>
      </div>
      <div>
        <p class="about-meet-body">
          Sydea &egrave; una societ&agrave; italiana di consulenza IT specializzata in SAP/ERP, sviluppo software e automazione dei processi aziendali. Operiamo da Bologna, Napoli, Skopje e Vancouver con team internazionali e competenze verticali.
        </p>
        <p class="about-meet-body">
          Sydea is an Italian IT consulting firm specialising in SAP/ERP, software development, and business process automation. We operate from Bologna, Naples, Skopje and Vancouver with deep vertical expertise.
        </p>
      </div>
    </section>

    <footer-meet>
      <span class="footer-meet-logo-meet">Sydea<span>.</span></span>
      <ul class="footer-meet-links">
        <li><a href="https://www.sydea.it" target="_blank">sydea.it</a></li>
        <li><a href="mailto:info@sydea.com">info@sydea.com</a></li>
        <li><a href="https://www.linkedin.com/company/sydea" target="_blank">LinkedIn</a></li>
      </ul>
      <span class="footer-meet-copy">&copy; 2026 Sydea S.r.l.</span>
    </footer-meet>
  `;

  return (
    <div style={{background: '#f6f6f6'}}>{parse(megastring)}</div>
  );
};
